module.exports = __webpack_public_path__ + "img/game_main_pc_009_off.ba73f104.png";